import styled from 'styled-components';

export const OfferDemandContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 5% 55% 40%;
`;

// Styled components (you'll need to create these)

export const OfferDemandGraphContainer = styled.div`
  width: 90%;
  height: 70%;
  display: flex;
  flex-direction: column;
  justify-self: center;
  justify-content: center;
  align-items: center;
  row-gap: 30px;
  box-sizing: border-box;
`;

type OfferBarProps = {
  height: string;
};
export const OfferBar = styled.div<OfferBarProps>`
  width: 40%;
  background-color: #b6bbc6;
  border-radius: 30px 30px 0 0;
  height: ${({ height }) => height || '1%'};
`;

export const DemandBar = styled.div<OfferBarProps>`
  width: 40%;
  background-color: #363c4b;
  border-radius: 30px 30px 0 0;
  height: ${({ height }) => height || '1%'};
`;

export const BarGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  height: 100%;
`;

export const XAxis = styled.div`
  position: relative;
  width: 90%;
  height: 100%;
  left: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-size: 10px;
  margin: 0 40px;
  color: #212632;
  z-index: 1;
  border-bottom: 2px solid #ccc;
`;

export const XAxisLabel = styled.span`
  position: relative;
  width: 10%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
`;

export const RangeLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #212632;
  white-space: nowrap;
`;
export const TagLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #747d93;
  white-space: nowrap;
`;

export const XLabelsContainer = styled.div`
  position: absolute;
  width: 100%;
  bottom: -50px;
  display: flex;
  flex-direction: column;
`;

// info

export const OfferDemandCardsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 40% 30% 30%;
  grid-gap: 10px;
  align-items: center;
  box-sizing: border-box;
`;

export const OfferDemandCardsContent = styled.div`
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
`;

export const OfferDemandCard = styled.div<{ align?: string }>`
  width: 100%;
  height: 100%;
  background-color: #fafbfc;
  border-radius: 15px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const OfferDemandCardInfo = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const OfferDemandCardInfoValue = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 5px;
  align-items: center;
`;

export const SectionTitle = styled.span`
  display: flex;
  align-self: flex-start;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #212632;
`;

export const OfferDemandCardLabel = styled.span<{ align?: string }>`
  width: 100%;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #212632;
  text-align: ${(props) => props.align || 'center'};
`;

export const OfferDemandCardMainValue = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #212632;
`;
export const OfferDemandCardSecondaryValue = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #747d93;
`;

export const OfferDemandLegendContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  column-gap: 15px;
`;

export const OfferDemandLegendDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background-color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OfferDemandLegendLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 5px;
  font-size: 12px;
  color: #747d93;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
`;

export const OfferDemandNoData = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 10px;
`;
